export class Interpretation {

  public title: string;
  public related: string;
  public committee: boolean;
  public text: string;
  public docname: string;
  public docmime: string;
  public doclink: string;

  constructor(rawArticle: any) {
    this.title = rawArticle.title;
    this.related = rawArticle.related;
    this.committee = rawArticle.committee;
    this.text = rawArticle.text;
    this.docname = rawArticle.docname;
    this.docmime = rawArticle.docmime;
    this.doclink = rawArticle.doclink;

  }
}
